// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-l_gP","advertDetailContactGroup__header":"c-l_gQ","advertDetailContactGroup__value":"c-l_gR"};